/**
 * Shared helper utilities for driver operations.
 */

import { Driver } from '../services/api';

/**
 * Check if a driver has valid consent for licence checking.
 * Consent is valid if:
 * - consentProvided is true
 * - consentExpiry exists and is in the future
 */
export const hasValidConsent = (driver: Driver): boolean => {
    const now = new Date();
    return !!(
        driver.consentProvided &&
        driver.consentExpiry &&
        new Date(driver.consentExpiry) > now
    );
};
